module.exports = __webpack_public_path__ + "media/video3.b72b64d4.webm";